$(document).ready(function() {
  // Custom collection slider
  if ($('.collectionSlider').length) {
    $('.collectionSlider').slick({
      dots: false,
      speed: 800,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      infinite: true,
      nextArrow: '<img class="arrow_left" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Arrow_Left.png?v=1724758729" />',
      prevArrow: '<img class="arrow_right" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Arrow_Right.png?v=1724758841"/>',
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // Featured collection slider
  if ($('.featuredSlider').length) {
    $('.featuredSlider').slick({
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      nextArrow: '<img class="arrow_left" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Arrow_Right_1.png?v=1724847292" />',
      prevArrow: '<img class="arrow_right" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Arrow_Left_1.png?v=1724847291"/>',
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // Featured collection slider two
  if ($('.featuredSlider2').length) {
    $('.featuredSlider2').slick({
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      nextArrow: '<img class="arrow_left" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Group_26.png?v=1724908299" />',
      prevArrow: '<img class="arrow_right" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Group_27.png?v=1724908299"/>',
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // Hotspot section
  if ($('.featuredHotspot').length) {
    $('.featuredHotspot').slick({
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      nextArrow: '<img class="arrow_left" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Arrow_Right_2.png?v=1724853434" />',
      prevArrow: '<img class="arrow_right" src="https://cdn.shopify.com/s/files/1/0760/2369/3642/files/Arrow_Left_2.png?v=1724853434"/>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  // Collection tabs
  $("#tabs").tabs();

  // Search close button
  $('.btn--close-search').on('click', function(event) {
    event.preventDefault();
    $(this).closest('.site-header__search-container').removeClass('is-active');
    $(this).closest('predictive-search').removeClass('is-active');
  });
});
